export function initHeaderTopNavigation() {
    const nav = document.querySelector('.headerTopNavigation');
    if (!nav) return;

    const currentPath = window.location.pathname;

    nav.querySelectorAll('a').forEach(link => {
        try {
            const linkPath = new URL(link.href, window.location.origin).pathname;
            if (linkPath === currentPath || currentPath.endsWith(linkPath)) {
                link.classList.add('is-active');
            }
        } catch {
            // skip malformed hrefs
        }
    });
}